const CLICK_ID = 1;
const DIET_ID = 2;
const ALLERGEN_ID = 3;

module.exports = {
    parseOutput : function(output){
        let clicks = {weekly: 0, monthly: 0, yearly: 0};
        let diets  = {weekly: {}, monthly: {}, yearly: {}};
        let allergens = {weekly: {}, monthly: {}, yearly: {}};

        for(let i = 0; i < output.length; i++){
            switch(output[i].action){
                case CLICK_ID:
                    clicks.weekly = output[i].weekly;
                    clicks.monthly = output[i].monthly;
                    clicks.yearly = output[i].yearly;
                    break;
                case DIET_ID:
                    let dietName = output[i].data;
                    diets.weekly[dietName] = output[i].weekly;
                    diets.monthly[dietName] = output[i].monthly;
                    diets.yearly[dietName] = output[i].yearly;
                    break;
                case ALLERGEN_ID:
                    let allergenName = output[i].data;
                    allergens.weekly[allergenName] = output[i].weekly;
                    allergens.monthly[allergenName] = output[i].monthly;
                    allergens.yearly[allergenName] = output[i].yearly;
                    break;
                default:
                    break;
            }
        }
        return {"clicks": clicks, "diets": diets, "allergens": allergens};
    }
}


// WEBPACK FOOTER //
// ./src/views/Analytics/analyticsParser.js